// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"FormSubTitle_subTitle_3qCEF"};